var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.32 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 12.32,
    height: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIco);
export default __webpack_public_path__ + "static/media/minus-ico.537bc186515cab63669de97905a1d2e9.svg";
export { ForwardRef as ReactComponent };